if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"televet","remotes":[{"alias":"contract","name":"contract","entry":"contracts/static/js/remoteEntry.js","shareScope":"default"},{"alias":"contractLegacy","name":"contractLegacy","entry":"/contracts-legacy/_next/static/chunks/remoteEntry.js","shareScope":"default"},{"alias":"notification","name":"notification","entry":"/notification/_next/static/chunks/remoteEntry.js","shareScope":"default"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(3(034|292|732)|8(122|594|65)|1995|5534|9252)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}